"use strict";


/**
 * Событие срабатывает после удаления строки таблицы.
 * @param {integer} rowNum Номер удаленной строки.
 * @event WebAccess.current.form.controls.tables.TableName#deleteRow
 */

/**
 * Событие срабатывает после скрытия таблицы.
 * @event WebAccess.current.form.controls.tables.TableName#hide
 */

/**
 * Событие срабатывает после отображения таблицы.
 * @event WebAccess.current.form.controls.tables.TableName#show
 */

/**
 * Событие срабатывает после включения таблицы.
 * @event WebAccess.current.form.controls.tables.TableName#enable
 */

/**
 * Событие срабатывает после отключения таблицы.
 * @event WebAccess.current.form.controls.tables.TableName#disable
 */

/**
 * Событие срабатывает после добавления или удаления строки таблицы.
 * @event WebAccess.current.form.controls.tables.TableName#change
 */

(function (global) {

  /**
  * Команды для сохранения карточки объекта.
  * @inner
  */
  var COMMAND = {
    ADD_ROW: 1,
    DELETE_ROW: 2
  };

  /**  
  * Имя реквизита "Номер строки"
  * @inner
  */
  var ROW_NUMBER = {
    VALUE: L('DETAIL_REQ_NUMBER'),
    DISPLAY_VALUE: 'Field_' + L('DETAIL_REQ_NUMBER')
  }

  /**
  * Класс для хранения списка столбцов таблицы и 
  * предоставления методов для работы с ними.  
  * @class ColumnsCollection
  * @extends BaseTableCollection
  */
  var ColumnsCollection = WebAccess.Collection.extend({
    className: "ColumnsCollection",

    /**
    * Родительская таблица.
    * @property ColumnsCollection#_parentTable //
    * @private
    * @since 5.0.0.7100
    */
    _parentTable: null,
    _data: null,
    _isChanged: false,

    init: function (colsData, parentTable, grid) {
      var me = this;
      me._super();
      me._parentTable = parentTable;
      me._data = colsData;
      var num = 0;
      for (var reqName in colsData) {
        me.addElement(reqName, me._createTableColumn(reqName, null, num));
        num++;
      }
    },
    //---------------------------------------------------------------------//

    /**
    * Создает объект колонки.
    * @method ColumnsCollection#_createTableColumn
    * @private
    * @since 5.0.0.7100
    */
    _createTableColumn: function (reqName, isDisabled, num) {
      var newCol = new WebAccess.components.wrappers.form.TableColumn(reqName, this._parentTable, num);
      if (isDisabled) {
        newCol.disable();
      }
      return newCol;
    },
    //---------------------------------------------------------------------//

    /**
    * Получает список видимых колонок таблицы.
    * @method ColumnsCollection#getVisibleColumns
    * @return {object} Массив TableColumn.
	* @since 5.5.0.1007
    */
    getVisibleColumns: function () {
      return this._arr.filter(function (column) {
        return column.isVisible;
      });
    }
  });
  //-----------------------------------------------------------------------//

  /**
  * Класс для хранения списка строк таблицы и 
  * предоставления методов для работы с ними.  
  * @class RowsCollection
  * @extends BaseTableCollection
  */
  var RowsCollection = WebAccess.Collection.extend({
    className: "RowsCollection",

    /**
    * Родительская таблица.
    * @method RowsCollection#_parentTable
    * @private
    * @since 5.0.0.7100
    */
    _parentTable: null,
    Init: null,
    //---------------------------------------------------------------------//

    init: function (rowsData, parentTable, grid) {
      var me = this;
      me._super();
      me._grid = grid;
      me._parentTable = parentTable;

      me.Init = $.Deferred();
      var rowsInit = [];

      for (var rowId in rowsData) {
        var currentRow = me._addRow(rowId, rowsData[rowId], false);
        rowsInit.push(currentRow.Init);
      }

      $.when.apply(null, rowsInit).then(function () {
        me.Init.resolve();
      });
    },
    //---------------------------------------------------------------------//

    /**
    * Добавляет новую строку в коллекцию.
    * @method RowsCollection#_addRow
    * @return {object} Строка детального раздела.
    * @private
    * @since 5.0.0.7100
    */
    _addRow: function (rowID, rowData, isNew) {
      var me = this;
      var parentTableSelector = me._parentTable.selector;
      var row = new WebAccess.components.wrappers.form.TableRow(parentTableSelector + ' #' + rowID, rowID, rowData, isNew, me._parentTable, me._grid);
      me.addElement(rowID, row);
      return row;
    },
    //---------------------------------------------------------------------//

    /**
    * Удаляет строку из коллекции.
    * @method RowsCollection#_deleteRow
    * @private
    * @since 5.0.0.7100
    */
    _deleteRow: function (rowID) {
      this.deleteElement(rowID);
    },
    //---------------------------------------------------------------------//

    /**
    * Удаляет строку детального раздела.
    * @method RowsCollection#deleteRow
    * @private
    * @since 5.0.0.7100
    */
    deleteRow: function (rowNum) {
      this._parentTable.deleteRow(rowNum);
      return this;
    }
    //---------------------------------------------------------------------//
  });
  //-----------------------------------------------------------------------//

  /**
  * Таблица. 
  * 
  * @class WebAccess.components.wrappers.form.Table
  * @extends BaseObject
  * @param {string} itemSelector Cуществующий элемент страницы
  * @param {object} formData Данные реквизитов таблицы
  * @property {string} name Имя таблицы
  * @property {string} selector Путь к объекту группы в DOM-иерархии
  * @property {integer} detailNum Номер детального раздела
  * @property {integer} detailName Номер детального раздела в строковом представлении. Параметр устаревший, оставлен для совместимости с ранними версиями
  * @property {integer} rows Строка таблицы
  * @property {integer} columns Колонка таблицы
  * @property {string} parentTabName Имя закладки, на которой располагается элемент
  * @example 
  * WA.CR.form.controls.tables.STcxGrid1.addRow({'ISBCoordX':{value:1, displayValue:'1'}})
  */
  var Table = BaseObject.extend({
    className: "Table",

    _grid: null,
    _uid: 0,
    _isDisabled: false,
    _currentForm: null,
    _columnsMetadata: {},
    _gridColumnsMetadata: {},

    detailNum: -1,
    detailName: "", //Оставлено для совместимости.
    rows: null,
    columns: null,
    parentTabName: null,
    _data: null,
    _hasPendingOperation: null, //для ограничения одновременно отправляемых запросов на сервер
    Init: null, // Событие таблица проинициализирована

    serviceURL: '/CardForm.asmx',

    _objectLink: null,
    _objectView: null,
    //---------------------------------------------------------------------//

    init: function (itemSelector, params) {

      this.Init = $.Deferred();

      this._currentForm = params.current.form;

      this.serviceURL = params.serviceURL || '/CardForm.asmx';
      this._objectLink = params.objectLink || $.toJSON(new WA.Link().toLinkModel());

      this._objectView = params.objectView;
      if (!this._objectView && this._objectView !== '') { //Пустая строка считается нормальным значением.
        this._objectView = WA.CR.getReferenceView();
      }

      this._hasPendingOperation = {
        'addRow': false,
        'copyRow': false,
        'deleteRow': false
      };

      if (!params.formData) return;
      this._super(params.formData);
      this._data = params.formData;


      this._jObject = $(itemSelector);

      this.parentTabName = this._jObject.parents('.CardForm_Tab').data('dfmName');

      this.name = this._jObject.attr("id");

      this._grid = params.grids[this.name];
      this._grid.setTable(this);

      this.selector = "#" + this.name;

      this.detailNum = +this._jObject.data('detailSectionNumber');

      this.detailName = '' + this.detailNum; //Оставлено для совместимости.
      this._isDisabled = this._data.isreadonly || this._jObject.data('readonly');
      this._uid = 0;

      // Если нет вкладок, инициализируем таблицу.ColumnsCollection
      this._initColumns()
      this._initRows();

      $.when(this.rows.Init).then(() => {
        // Событие изменения строки
        var tableRows = this.rows.toArray();
        tableRows.forEach((row) => {
          row.bind(row.class.EVENT.CHANGE, () => {
            this.fire(this.class.EVENT.CHANGE);
          });
        });

        this.bind(this.class.EVENT.ROW_ADDED, (newRow) => {
          newRow.bind(newRow.class.EVENT.CHANGE, () => {
            this.fire(this.class.EVENT.CHANGE);
          });
        });

        this.Init.resolve();
      });
    },
    //---------------------------------------------------------------------//

    _initColumns: function () {
      var me = this;
      me._columnsMetadata = me.getColumnsMetadata();
      me._gridColumnsMetadata = {};

      // Получить информацию о колонках
      me._columnsMetadata.forEach(function (currentColumn) {
        var reqName = currentColumn.Name;
        me._gridColumnsMetadata[reqName] = {
          fieldName: "Field_" + reqName,
          isVisible: currentColumn.IsVisible,
          isReadOnly: currentColumn.IsReadOnly,
          type: requisiteTypeToString(currentColumn.Type),
          isRequired: currentColumn.IsRequired,
          hasCalculation: currentColumn.HasCalculation,
          isSystem: currentColumn.IsSystem
        }
      });

      me.columns = new ColumnsCollection(me._gridColumnsMetadata, me, me._grid);
    },

    _initRows: function () {
      var me = this;
      var rows = me._grid.dataView.getItems() || [];
      var rowsData = me._makeRowsData(rows);
      me.rows = new RowsCollection(rowsData, me, me._grid);
      me.fire(me['class'].EVENT.DATA_RELOADED, me);
    },
    //---------------------------------------------------------------------//

    _makeEmptyRow: function (id, opt_row) {
      var me = this;
      var row = _(me.columns).mapObject(function (val, key) { return '' });
      if (opt_row) $.extend(row, opt_row);
      row.id = id;
      return row;
    },

    //---------------------------------------------------------------------//

    /**
    * Создает данные для построения реквизитов новой строки
    * @private
    */
    _makeRowsData: function (rows) {
      var me = this;
      var rowsMetadata = {};

      for (var i = 0; i < rows.length; i++) {
        var rowId = rows[i]['id'];
        me._columnsMetadata.forEach(function (columnMetadata) {
          var columnRequisiteName = columnMetadata.Name;

          var gridColumnMetadata = me._gridColumnsMetadata[columnRequisiteName];
          var currentColumn = me.columns[columnRequisiteName];
          var requisiteMetadata = {
            row_id: rowId,
            fieldName: gridColumnMetadata.fieldName,
            value: rows[i][columnRequisiteName],
            displayValue: rows[i][gridColumnMetadata.fieldName],
            isVisible: currentColumn.isVisible(),
            isReadOnly: currentColumn.isDisabled() || me.isDisabled(),
            type: gridColumnMetadata.type,
            isRequired: gridColumnMetadata.isRequired,
            hasCalculation: gridColumnMetadata.hasCalculation,
            isSystem: gridColumnMetadata.isSystem
          };

          if (!rowsMetadata[rowId]) {
            rowsMetadata[rowId] = {
              id: rowId,
              requisitesData: {}
            };
          }
          rowsMetadata[rowId]['requisitesData'][columnRequisiteName] = requisiteMetadata;
        });
      }

      return rowsMetadata;
    },
    //---------------------------------------------------------------------//

    /**
    * Сбрасывает выделение с ячейки.
    * @method WebAccess.components.wrappers.form.Table#resetActiveCell
	* @since 5.0.0.2706
    */
    resetActiveCell: function () {
      var me = this;
      var grid = me._grid.grid;
      var activeCell = grid.getActiveCell();
      if (activeCell) {
        grid.resetActiveCell();
      }
    },
    //---------------------------------------------------------------------//

    /**
    * Признак изменения реквизитов таблицы.
    * @since 5.0.0.7100
    * @method WebAccess.components.wrappers.form.Table#isChanged
    * @return {boolean} True – таблица была изменена, иначе False.
    */
    isChanged: function () {
      if (this._isChanged === true) return true;
      var rows = this.rows.toArray();
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].isChanged()) {
          return true;
        }
      }
      return false;
    },
    //---------------------------------------------------------------------//

    /**
    * Признак недоступности реквизитов таблицы.
    * @method WebAccess.components.wrappers.form.Table#isDisabled
    * @return {boolean} True, если реквизиты таблицы не доступны для изменения, иначе False.
    * @since 5.0.0.7100
    */
    isDisabled: function () {
      return this._isDisabled;
    },
    //---------------------------------------------------------------------//

    /**
    * Получает метаданные по колонкам таблицы.
    * @method WebAccess.components.wrappers.form.Table#getColumnsMetadata
    * @return {object} Список объектов с информацией о колонках.
    */
    getColumnsMetadata: function () {
      return this._jObject.data('columns');
    },
    //---------------------------------------------------------------------//


    /**
    * Получает метаданные по колонке таблицы.
    * @method WebAccess.components.wrappers.form.Table#getColumnMetadata
    * @param {string} columnName Имя колонки, по которой получаются метаданные.
    * @return {object} Метаданные по колонке.
    */
    getColumnMetadata: function (columnName) {
      if (columnName) {
        var columnsMetadata = this.getColumnsMetadata();
        var columnMetadata = columnsMetadata.filter(function (item) {
          return item.Name === columnName;
        });
        if (columnMetadata.length > 0) return columnMetadata[0];
      }
      return;
    },

    /**
    * Скрыть таблицу.
    * @method WebAccess.components.wrappers.form.Table#hide
    * @fires WebAccess.components.wrappers.form.Table#hide
    * @return {WebAccess.components.wrappers.form.Table} Объект типа Table.
    */
    hide: function () {
      this._jObject.css('visibility', 'hidden');
      this.fire('hide');
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Отобразить таблицу.
    * @method WebAccess.components.wrappers.form.Table#show
    * @fires WebAccess.components.wrappers.form.Table#show
    * @return {WebAccess.components.wrappers.form.Table} Объект типа Table.
    */
    show: function () {
      this._jObject.css('visibility', 'visible');
      this.fire('show');
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Сделать доступными реквизиты таблицы.
    * @method WebAccess.components.wrappers.form.Table#enable
    * @fires WebAccess.components.wrappers.form.Table#enable
    * @return {WebAccess.components.wrappers.form.Table} Объект типа Table.
    */
    enable: function () {
      var me = this;
      var rows = me.rows.toArray();
      for (var i = 0; i < rows.length; i++) {
        rows[i].enable();
      }
      me._isDisabled = false;
      me.fire('enable');
      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * Сделать недоступными реквизиты таблицы.
    * @method WebAccess.components.wrappers.form.Table#disable
    * @fires WebAccess.components.wrappers.form.Table#disable
    * @return {WebAccess.components.wrappers.form.Table} Объект типа Table.
    */
    disable: function () {
      var me = this;
      var rows = me.rows.toArray();
      for (var i = 0; i < rows.length; i++) {
        rows[i].disable();
      }
      me._isDisabled = true;
      me.fire('disable');
      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * Получить столбцы таблицы. 
    * Столбцы в данном случае – объекты типа TableColumn.
    *
    * @method WebAccess.components.wrappers.form.Table#getColumns
    * @see Column
    * @see ColumnsCollection
    * @return {ColumnsCollection} Объект типа ColumnsCollection.
    */
    getColumns: function () {
      return this.columns;
    },
    //---------------------------------------------------------------------//

    /** 
    * Обновить идентификатор строки
    * @private 
    */
    _updateRowID: function (oldId, newId) {
      var me = this;
      var dataView = me._grid.dataView;
      var row = dataView.getItemById(oldId);
      if (!row) return this;

      row.id = newId;
      this.rows.deleteElement(oldId)
      dataView.deleteItem(oldId)
      dataView.addItem(row);
      var rowsData = me._makeRowsData([row]);
      this.rows._addRow(newId, rowsData[newId], false);
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Получить строки таблицы. 
    * Строки в данном случае – объекты типа TableRow.
    *
    * @method WebAccess.components.wrappers.form.Table#getRows
    * @see Row
    * @see RowsCollection
    * @return {Object} Объект содержащий строки таблицы. Ключом является номер строки. Также в объекте есть метод count, возвращающий количество строк.
    * @deprecated since 5.0.0.7100
    */
    getRows: function () {
      var me = this;
      var resultRowsByName = {};
      var rows = me.rows.toArray();
      for (var rowI = 0; rowI < rows.length; rowI++) {
        resultRowsByName[rows[rowI].name] = rows[rowI];
      }
      resultRowsByName['count'] = function () {
        return me.rows.count();
      };
      return resultRowsByName;
    },
    //---------------------------------------------------------------------//

    _getGeneratedRow: function (isBuilderEventsSupported, opt_requisiteValues, opt_sync) {
      var me = this;
      me._uid -= 1;

      var newRowNumber = me._getNextRowNumber();

      var result = $.Deferred();

      if (isBuilderEventsSupported) {
        me._hasPendingOperation['addRow'] = true;

        me._sendRequest('CreateTableRow', {
          Obj: me._objectLink,
          Requisites: opt_requisiteValues || {},
          View: me._objectView,
          DetailNum: me.detailNum,
          Number: newRowNumber
        }, opt_sync).done(function (data) {
          if (data !== "") {
            data = $.parseJSON(data);

            result.resolve(data);
          }
        }).fail(function (errorMessage, response) {
          // В ответе с ошибкой могут прийти изменения других реквизитов и их надо будет обработать.
          if (response && response.Result) {
            var data = $.parseJSON(response.Result);
            result.reject(data);
          }
        }).always(function () {
          me._hasPendingOperation['addRow'] = false;
        });
      } else {
        // Здесь нам нужны все реквизиты, иначе потом в случае ошибки 
        // мы не сможем полноценно обновить эту строку в методе updateRowID
        var row = me.columns.toArray()
          .filter(function (col) { return !col.isSystem(); }) //пропускаем системные реквизиты, т.к. их нельзя устанавливать.
          .reduce(function (prev, curr) { prev[curr.name] = null; return prev; }, {}); // преобразуем массив колонок в объект типа {colName1: null, ...}

        row.id = me._uid;
        row[ROW_NUMBER.VALUE] = row[ROW_NUMBER.DISPLAY_VALUE] = newRowNumber;

        // Устанавливаем значение реквизитов.
        if (!!opt_requisiteValues) {
          for (var reqName in opt_requisiteValues) {
            var reqValue = opt_requisiteValues[reqName];
            if (!_.isUndefined(row[reqName])) {
              row[reqName] = reqValue.value;
              row['Field_' + reqName] = reqValue.displayValue;
            }
          }
        }

        me._currentForm._commandList.push({
          CmdCode: COMMAND.ADD_ROW,
          Section: me.detailNum,
          ID: me._uid
        });

        result.resolve({ RowData: row });
      }
      return result;
    },
    //---------------------------------------------------------------------//

    /**
    * Генерирует следующий номер строки.
    * @private
    */
    _getNextRowNumber: function () {
      var me = this;
      var lastRowNum = 0;

      var dataView = me._grid.dataView;
      var exisitingRows = dataView.getItems() || [];

      if (exisitingRows.length) {
        var lastRowNum = _(exisitingRows).chain().map(function (r) {
          return +r[ROW_NUMBER.VALUE]
        }).max().value();
      }

      return +lastRowNum + 1;
    },
    //---------------------------------------------------------------------//

    /**
    * Добавить строку детального раздела.
    *
    * @function WebAccess.components.wrappers.form.Table#addRow
    * @param {object} opt_requisiteValues Значение реквизитов в формате: 
    * {'имя реквизита': {value: 'значение', displayValue: 'отображаемое значение', 'needTriggerResult': 'true|false нужно ли вызывать событие на установку значения (по умолчанию true)'},...}
    * @param {function} opt_callback Функция для добавления строки. Предназначена для совместимости. Рекомендуется использовать событие типа addRow
    * @param {boolean} opt_sync Признак синхронного создания строки. Предназначен для свместимости. Рекомендуется использовать асинхронное создание строки
    * @fires WebAccess.components.wrappers.form.Table#addRow
    * @fires WebAccess.components.wrappers.form.Table#change
    * @return {WebAccess.components.wrappers.form.Table} Объект типа Table.
    */
    addRow: function (opt_requisiteValues, opt_callback, opt_sync) {
      var me = this;

      if (me._hasPendingOperation['addRow']) return me;

      me._getGeneratedRow(me._grid.settings.isBuilderEventsSupported, opt_requisiteValues, opt_sync).done(function (data) {
        var row = data.RowData;
        var changes = data.Changes;
        var changedMultiSelects = data.ChangedMultiSelectRequisitesValues;
        me._appendNewRowToDataView(row, changes, changedMultiSelects, function (tableRow) {
          // Отбираем колонки, у которых CanGUIRead = false
          var currentTableColumns = me.columns.toArray();
          currentTableColumns.forEach(function (column) {
            var reqName = column.reqName;
            var currentRequisite = tableRow.requisites[reqName];
            if (!column.getCanGUIRead()) {
              currentRequisite.setValue('*', '*', false);
              currentRequisite.setUntouched();
            }
            if (!!opt_requisiteValues && opt_requisiteValues[reqName] && opt_requisiteValues[reqName].needTriggerResult) {
              currentRequisite.touch();
            }
          });

          // Установить состояния реквизитов
          tableRow._disableReadOnlyFields();

          if ($.isFunction(opt_callback)) opt_callback(tableRow);
        });
      }).fail(function (data) {
        var changes = data.Changes;
        var changedMultiSelects = data.ChangedMultiSelectRequisitesValues;
        me.fire('applychanges', null, changes, me, changedMultiSelects);
      });

      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * Копирует строку детального раздела на сервере.
    *
    * @function WebAccess.components.wrappers.form.Table#copyRowOnServer
    * @param {integer} sourceRowId ИД копируемой строки
    * @param {object} opt_requisiteValues Значение реквизитов в формате: 
    * {'имя реквизита': {value: 'значение', displayValue: 'отображаемое значение', 'needTriggerResult': 'true|false - признак необходимости вызывать событие для установки значения (по умолчанию true)'},...}
    * @param {function} opt_callback Функция для добавления строки. Предназначена для обратной совместимости с предыдущими версиями. Рекомендуется использовать событие типа addRow
    * @param {boolean} opt_sync Признак синхронного создания строки. Предназначен для обратной совместимости с предыдущими версиями. Рекомендуется использовать асинхронное создание строки
    * @fires WebAccess.components.wrappers.form.Table#addRow
    * @fires WebAccess.components.wrappers.form.Table#change
    * @return {WebAccess.components.wrappers.form.Table} Объект типа Table.
    * @since 5.2.0.1300
    */
    copyRowOnServer: function (sourceRowId, opt_requisiteValues, opt_callback, opt_sync) {
      var me = this;

      if (me._hasPendingOperation['copyRow']) return me;

      var result = $.Deferred();
      var newRowNumber = me._getNextRowNumber();

      me._hasPendingOperation['copyRow'] = true;

      me._sendRequest('CopyTableRow', {
        Obj: me._objectLink,
        View: me._objectView,
        DetailNum: me.detailNum,
        SourceRowID: sourceRowId,
        Number: newRowNumber,
        Requisites: opt_requisiteValues || {}
      }, opt_sync).done(function (data) {
        data = $.parseJSON(data);
        result.resolve(data);
      }).fail(function (errorMessage, response) {
        // В ответе с ошибкой могут прийти изменения других реквизитов и их надо будет обработать.
        if (response && response.Result) {
          var data = $.parseJSON(response.Result);
          result.reject(data);
        }
      }).always(function () {
        me._hasPendingOperation['copyRow'] = false;
      });

      // Строка скопирована, добавляем в DataSource.
      result.done(function (data) {
        var row = data.RowData;
        var changes = data.Changes;
        var changedMultiSelects = data.ChangedMultiSelectRequisitesValues;
        me._appendNewRowToDataView(row, changes, changedMultiSelects, opt_callback);
      }).fail(function (data) {
        var changes = data.Changes;
        var changedMultiSelects = data.ChangedMultiSelectRequisitesValues;
        me.fire('applychanges', null, changes, me, changedMultiSelects);
      });

      return me;
    },
    //---------------------------------------------------------------------//

    _appendNewRowToDataView: function (row, changes, changedMultiSelects, opt_callback) {
      var me = this;
      me.fire(me.class.EVENT.BEFORE_ROW_ADDED, me);

      var dataView = me._grid.dataView;
      dataView.addItem(row);
      dataView.refresh();
      row = me._makeEmptyRow(row.id, row);

      var rowsData = me._makeRowsData([row]);
      me.rows._addRow(row.id, rowsData[row.id], true);

      if ($.isFunction(opt_callback)) opt_callback(me.rows[row.id]);

      me._isChanged = true;
      // В диалогах не срабатывает событие добавления строки, для остальных объектов событие срабатывает при обновлении данных на форме.
      if (me._currentForm._current._jDialog) {
        me.fire(me.class.EVENT.ROW_ADDED, me.rows[row.id], me);
      }
      me.fire('change', me.rows[row.id], me);
      me.fire('applychanges', me.rows[row.id], changes, me, changedMultiSelects);

      return me;
    },
    //---------------------------------------------------------------------//

    _tryToDeleteRow: function (rowID, isBuilderEventsSupported, opt_sync) {
      var me = this;
      var result = $.Deferred();

      if (isBuilderEventsSupported) {
        me._hasPendingOperation['deleteRow'] = true;

        me._sendRequest('DeleteTableRow', {
          Obj: me._objectLink,
          View: me._objectView,
          DetailNum: me.detailNum,
          RowID: rowID
        }, opt_sync).done(function (data) {
          if (data) data = $.parseJSON(data);
          result.resolve(rowID, data);
        }).fail(function (errorMessage, response) {
          // В ответе с ошибкой могут прийти изменения других реквизитов и их надо будет обработать.
          if (response && response.Result) {
            var data = $.parseJSON(response.Result);
            result.reject(rowID, data);
          }
        }).always(function () {
          me._hasPendingOperation['deleteRow'] = false;
        });
      } else {
        var commands = me._currentForm._commandList;
        var existingCommand = _(commands).findWhere({ 'ID': rowID, 'CmdCode': COMMAND.ADD_ROW, Section: +me.detailNum });

        if (existingCommand) {
          //Если удаляем только что добавленую строку, то удаляем и команду на добавление
          me._currentForm._commandList = _(commands).filter(function (cmd) {
            return ((cmd.ID !== rowID) || (cmd.Section !== +me.detailNum))
          });
        } else {
          //Если удаляем существующую строку, то добавим команду на её удаление
          me._currentForm._commandList.push({
            CmdCode: COMMAND.DELETE_ROW,
            Section: me.detailNum,
            ID: rowID
          });
        }
        result.resolve(rowID, {});
      }

      return result;
    },
    //---------------------------------------------------------------------//

    /**
    * Удалить строку детального раздела.
    *
    * @function WebAccess.components.wrappers.form.Table#deleteRow
    * @param {integer} rowNum Номер строки
    * @fires WebAccess.components.wrappers.form.Table#deleteRow
    * @fires WebAccess.components.wrappers.form.Table#change
    * @fires WebAccess.components.wrappers.form.Table#applychanges
    * @return {TableWebAccess.components.wrappers.form.Table} Объект типа Table.
    * @since 5.0.0.7100
    */
    deleteRow: function (rowId, opt_sync) {
      var me = this;

      if (me._hasPendingOperation['deleteRow']) {
        return me;
      }

      if (!isNaN(rowId)) {

        var dataView = me._grid.dataView;
        var row = dataView.getItemById(rowId);
        me._tryToDeleteRow(+rowId, me._grid.settings.isBuilderEventsSupported, opt_sync).done(function (id, data) {
          var changes = data.Changes;
          var changedMultiSelects = data.ChangedMultiSelectRequisitesValues;

          dataView.deleteItem(rowId);
          me.rows._deleteRow(rowId);
          me._isChanged = true;
          me.fire('deleteRow', rowId, row);
          me.fire('change', row, me);
          me.fire('applychanges', row, changes, me, changedMultiSelects);
        }).fail(function (id, data) {
          var changes = data.Changes;
          var changedMultiSelects = data.ChangedMultiSelectRequisitesValues;
          me.fire('applychanges', row, changes, me, changedMultiSelects);
        });

      } else {
        WA.raise('ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED');
      }
      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * Вернуть реквизит таблицы по ИД элемента управления.
    *
    * @method WebAccess.components.wrappers.form.Table#getRequisiteByControlId
    * @param {string} controlId ИД HTML-элемента.
    * @since 5.0.0.7100
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Объект реквизита.
    */
    getRequisiteByControlId: function (controlId) {
      log.warning('REQUISITE', 'This method was changed in last version and may work improperly.');
      var rowsArr = this.rows.toArray();
      for (var rowI = 0; rowI < rowsArr.length; rowI++) {
        var row = rowsArr[rowI];
        var reqs = row.requisites.toArray();
        for (var reqI = 0; reqI < reqs.length; reqI++) {
          var req = reqs[reqI];
          for (var j = 0; j < req.controlsIds.length; j++) {
            if (controlId === req.controlsIds[j]) {
              return req;
            }
          }
        }
      }
      return null;
    },
    //---------------------------------------------------------------------//

    /**
    * Возвращает строку таблицы по ИД.
    *
    * @method WebAccess.components.wrappers.form.Table#getRowById
    * @return {TableRow} Объект строки.
    * @since 5.2.0.1300
    */
    getRowById: function (rowId) {
      return this.rows[rowId];
    },
    //---------------------------------------------------------------------//

    /**
    * Обновляет данные таблицы.
    *
    * @method WebAccess.components.wrappers.form.Table#reloadData
    * @return {Deferred} Специальный deferred-объект
    * @since 5.2.0.1303
    */
    reloadData: function () {
      var me = this;
      log.warn('TABLE', 'Table reloaded. If you have any binded event handlers for rows or columns you must rebind them manualy');
      return this._grid.reloadData().done(function () {
        me._initRows();

        // Восстанавливаем логику ведущих ведомых после обновления страницы
        me._currentForm._current.bindLeaderDrivenLogicToTable(me);
      });
    },
    //---------------------------------------------------------------------//

    /**
    * Отправляет запрос на веб-сервис.
    * @private
    */
    _sendRequest: function (action, params, opt_sync) {
      var method = WA.SRV.call;
      if (opt_sync === true) {
        method = WA.SRV.callSync;
      }
      return method(this.serviceURL + '/' + action, params);
    },
    //---------------------------------------------------------------------//

    /**
    * Привязывает вызов справочника в модальном окне к клику на иконке в поле ввода.
    *
    * @method WebAccess.components.wrappers.form.Table#bindReferenceGridDialog
    * @param {String | Array<String>} requisites Имя или имена реквизитов для привязки логики вызова справочника в модальном окне
    * @return {TableWebAccess.components.wrappers.form.Table} Объект типа Table.
    * @since 5.4.0.1012
    */
    bindReferenceGridDialog: function (requisites) {
      var me = this;

      var colNames = typeof (requisites) === 'string' ? [requisites] : requisites;

      // На существующие строки.
      var rows = me.rows.toArray();
      for (var i = 0; i < rows.length; i++) {
        bindOnRowRequisites(rows[i]);
      }
      // На новые строки
      me.bind(me['class'].EVENT.ROW_ADDED, function (newRow) {
        bindOnRowRequisites(newRow);
      });

      function bindOnRowRequisites(row) {
        for (var j = 0; j < colNames.length; j++) {
          var req = row.requisites[colNames[j]]
          if (req) {
            req.bindReferenceGridDialog();
          }
        }
      }

      return me;
    },

    /**
   * Устанавливает признак isChanged в состояние false.
   *
   * @method WebAccess.components.wrappers.form.Table#setUntouched
   * @return {TableWebAccess.components.wrappers.form.Table} Объект типа Table.
   * @since 5.7.0
   */
    setUntouched() {
      this._isChanged = false;
      return this;
    },

  }, {
    EVENT: {
      /**
      * Событие срабатывает до добавления строки таблицы.
      *
      * @event WebAccess.components.wrappers.form.Table.EVENT.BEFORE_ROW_ADDED      
      * @param {object} context ссылка на экземпляр класса           
      * @since 5.7.0
      */
      BEFORE_ROW_ADDED: 'beforeAddRow',

      /**
      * Событие срабатывает после добавления строки таблицы.
      *
      * @event WebAccess.components.wrappers.form.Table.EVENT.ROW_ADDED
      * @param {TableRow} newRow Новая строка.
      * @param {object} context ссылка на экземпляр класса
      * @example
      * var table = WebAccess.current.form.controls.tables['STcxGrid1'];
      * table.bind(table['class'].EVENT.ROW_ADDED , function(newRow, table) {
      *   console.log(newRow);
      *   newRow.requisites['СодержаниеТ2'].setValue('тест', 'тест');
      * });
      * @since 5.2.0.2014
      */
      ROW_ADDED: 'addRow',
      //-------------------------------------------------------------------//

      /**
      * Событие срабатывает если данные в таблице были обновлены.
      *
      * @event WebAccess.components.wrappers.form.Table.EVENT.DATA_RELOADED
      * @param {object} context ссылка на экземпляр класса
      * @since 5.2.0.2014
      */
      DATA_RELOADED: 'dataReloaded',
      //-------------------------------------------------------------------//

      /**
      * Событие срабатывает, если данные в таблице были изменены.
      *
      * @event WebAccess.components.wrappers.form.Table.EVENT.CHANGE
      * @param {object} context Ссылка на экземпляр класса
      * @since 5.5.0.2201
      */
      CHANGE: 'change'
      //-------------------------------------------------------------------//
    }
  });

  global.Table = Table;
})(window.WebAccess.components.wrappers.form);
